<template>
  <v-dialog
    v-model="dialog"
    overlay-opacity=".1"
    :persistent="persistent"
  >
    <div v-if="attentionType" class="bg-white">
      <header class="d-flex align-center px-5 pt-3">
        <h4 class="flex-fill font-weight-light">{{ attentionType.title }}</h4>
        <v-btn
          elevation="0"
          icon
          small
          @click="hide"
          v-if="!persistent"
        >
          <Icon
            icon="close"
            :size="20"
            color="#333"
          />
        </v-btn>
      </header>
      <section class="body">
        <v-list>
          <v-list-item
            v-for="(item, index) in list.filter(item => attentionType.channels.includes(item.channel))"
            :key="`channel-${index}`"
            class="px-5 d-flex align-center channel-item py-2"
            @click="selectChannel(item)"
          >
            <article class="icon" :style="{ color: $vuetify.theme.currentTheme.primary }">
              <component :is="item.icon" />
            </article>
            <section>
              {{ $t(`attentionTypes.channels.${item.channel}.label`) }}
              <div
                :style="{
                  fontSize: '12px',
                  color: '#666666',
                }"
                v-if="$t(`attentionTypes.channels.${item.channel}.description`)"
              >
                {{ $t(`attentionTypes.channels.${item.channel}.description`) }}
              </div>
            </section>
          </v-list-item>
        </v-list>
      </section>
    </div>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapActions, mapState } from 'vuex'

@Component({
  props: {
    attentionType: {
      type: Object,
      default: () => (null)
    },
    persistent: {
      type: Boolean,
      default: () => (false)
    },
    open: {
      type: Boolean,
      default: () => (false)
    }
  },
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    MessageChatSquareIcon: () => import(/* webpackPrefetch: true */ '@/components/icons/MessageChatSquare.vue'),
    Microphone01Icon: () => import(/* webpackPrefetch: true */ '@/components/icons/Microphone01.vue'),
    PhoneIncoming01Icon: () => import(/* webpackPrefetch: true */ '@/components/icons/PhoneIncoming01.vue'),
    VideoRecorderIcon: () => import(/* webpackPrefetch: true */ '@/components/icons/VideoRecorder.vue'),
    WhatsappIcon: () => import(/* webpackPrefetch: true */ '@/components/icons/Whatsapp.vue')
  },
  computed: {
    ...mapState({
      channel: state => state.channel
    })
  },
  methods: {
    ...mapActions({
      setAttentionChannel: 'setAttentionChannel'
    })
  }
})
export default class ChannelSelector extends Vue {
  data () {
    return {
      dialog: false,
      list: [
        {
          icon: 'VideoRecorderIcon',
          channel: 'video'
        },
        {
          icon: 'Microphone01Icon',
          channel: 'voice'
        },
        {
          icon: 'MessageChatSquareIcon',
          channel: 'chat'
        },
        {
          icon: 'PhoneIncoming01Icon',
          channel: 'call'
        },
        {
          icon: 'WhatsappIcon',
          channel: 'whatsapp'
        }
      ]
    }
  }

  show () {
    this.dialog = true
  }

  hide () {
    this.dialog = false
  }

  toggle () {
    if (this.dialog) {
      this.hide()
    } else {
      this.show()
    }
  }

  selectChannel (item) {
    this.dialog = false
    this.setAttentionChannel(item.channel)
    this.$emit('selectedChannel', item.channel)
  }

  mounted() {
    if (this.open) {
      this.show()
    }
  }
}
</script>

<style scoped>
.icon {
  width: 25px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon svg {
  width: 20px;
  height: auto;
}

.v-dialog {
  margin: 0 !important;
}

.v-list-item__subtitle, .v-list-item__title {
  white-space: normal !important;
  line-height: 1.4 !important;
}

.channel-item {
  border-bottom: 1px solid #f0f0f0;
}

.channel-item:last-child {
  border-bottom: none;
}
</style>
